import { render } from "./indexfourbrowse.vue?vue&type=template&id=6413a235"
import script from "./indexfourbrowse.vue?vue&type=script&lang=js"
export * from "./indexfourbrowse.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__